const DEFAULT_TIMEOUT_MS = 120_000
const DEFAULT_CONTEXT_MESSAGES = 48

export function getApiTimeoutMs() {
  const raw = import.meta.env.VITE_API_TIMEOUT_MS
  const n = typeof raw === 'string' ? Number.parseInt(raw.trim(), 10) : NaN
  if (Number.isFinite(n) && n >= 5000 && n <= 600_000) return n
  return DEFAULT_TIMEOUT_MS
}

export function getChatContextMessageLimit() {
  const raw = import.meta.env.VITE_CHAT_CONTEXT_MESSAGE_LIMIT
  const n = typeof raw === 'string' ? Number.parseInt(raw.trim(), 10) : NaN
  if (Number.isFinite(n) && n >= 2 && n <= 200) return n
  return DEFAULT_CONTEXT_MESSAGES
}

export function getAuthHeaderName() {
  const raw = import.meta.env.VITE_API_AUTH_HEADER
  if (typeof raw === 'string' && raw.trim()) return raw.trim()
  return 'Authorization'
}

export function getAuthHeaderPrefix() {
  const raw = import.meta.env.VITE_API_AUTH_PREFIX
  if (typeof raw === 'string') {
    const trimmed = raw.trim()
    if (trimmed.toLowerCase() === 'bearer') return `${trimmed} `
    return raw
  }
  return 'Bearer '
}

export function isCredentialsRequired() {
  return import.meta.env.VITE_API_WITH_CREDENTIALS === 'true'
}
